// extracted by mini-css-extract-plugin
export default {"LimitsContainer":"pTI7ksqdTBvul2j9UlIO","ActionButton":"hW9bZ5NFmTDPb3Bhfs9T","ActionButtonDisabled":"KoTAnREtDsSflHFTcmpd","RevokeButton":"vFHdH7mikxcMTlZNTLla"};